import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class SpecialInsuranceCase  {
    _originalTypeClassName = "zERP.BO.SpecialInsuranceCase";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
SpecialInsuranceCase.translate = translateService;
}
this.Versions = [];
this.Id = null;
this.Code = null;
this.Name = null;
this.SystemOwner = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Code:any;
Name:any;
SystemOwner:any;
Versions:any;
static setVersions = ($this, items) => {
                if (items == null) items = [];
                if ($this.Versions == null) $this.Versions = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Versions.length > 0) {
                    Domain.SpecialInsuranceCase.removeVersions($this, $this.Versions[0]);
                }

                Domain.SpecialInsuranceCase.addManyVersions($this, copyItems);
            }
static addManyVersions = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.SpecialInsuranceCase.addVersions($this, items[i]);
                }
            }
static addVersions = ($this, item) => {
                if ($this.Versions == null) $this.Versions = [];
                if (item == null || $this.Versions.indexOf(item) > -1) return;
                $this.Versions.push(item);
if (item.SpecialInsuranceCase != $this) {
Domain.SpecialInsuranceCaseVersion.setSpecialInsuranceCase(item, $this);
}
}
static addRangeVersions = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.SpecialInsuranceCase.addVersions($this, item));
            }
static removeVersions = ($this, item) => {
                if ($this == null || $this.Versions == null || $this.Versions.indexOf(item) === -1) return;
                var _index = $this.Versions.indexOf(item);
                $this.Versions.splice(_index, 1);
item.SpecialInsuranceCase = null;
}
static clearVersions = ($this) => { $this.Versions = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}